module.exports = __webpack_public_path__ + "img/patch.8c582c9f.svg";